import type { BlokFetcherProps, BlokProps } from "@trydig/storyblok";
import { rpc } from "#rpc";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { FeaturedCollectionHighlighted } from "@/components/ui/sections/FeaturedCollectionHighlighted";
import type { ProductsRoute } from "@/data/routes/products.route";
import type { FeaturedCollectionHighlightedStoryblok } from "@/generated/sb/sb-types";
import { sbLink } from "@/lib/storyblok/link";
import { checkBlokBackground } from "@/lib/utils/isDarkMode";

const clampLimit = (raw: string | number | undefined) => {
	const n = typeof raw === "number" ? raw : Number(raw ?? 3);
	if (!Number.isFinite(n) || n < 1) return 3;
	return Math.min(12, Math.floor(n));
};

export const featuredCollectionHighlightedFetcher = async ({
	blok,
}: BlokFetcherProps<FeaturedCollectionHighlightedStoryblok>) =>
	rpc.products.exploration({
		ids: blok.products,
		categoryId: blok.centraCategory,
		limit: clampLimit(blok.productLimit),
	});

export const featuredCollectionHighlightedKey = ({
	blok,
}: BlokFetcherProps<FeaturedCollectionHighlightedStoryblok>) => [
	...(blok.products ?? []),
	blok.centraCategory ?? "",
	String(blok.productLimit ?? 3),
];

export const FeaturedCollectionHighlightedBlok = ({
	blok,
	data,
}: BlokProps<FeaturedCollectionHighlightedStoryblok, ProductsRoute["exploration"]>) => {
	const linkHref = sbLink(blok.link)?.href;
	const bg = checkBlokBackground(blok);

	return (
		<BlokWrap editable={blok} asChild>
			<FeaturedCollectionHighlighted
				caption={blok.caption || undefined}
				heading={blok.heading || undefined}
				description={blok.description || undefined}
				linkLabel={blok.linkLabel || undefined}
				linkHref={linkHref}
				products={data?.products ?? []}
				bg={bg}
			/>
		</BlokWrap>
	);
};
